/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

import Vue from 'vue';
import Store from '@/socialFeed/store';
import App from '@/socialFeed/App';
import Blue from '../js/core';

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Blue({
	name: 'Social Feed App',
	selector: '#socialFeed',
	setup(el) {
		const app = new Vue({
			store: new Store().store,
			data: () => Object.assign({}, el.dataset),
			render: h => h(App)
		});
		app.$mount(el)
	}
}, false)
